import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ApiHttp } from 'app/providers';

@Injectable()
export class PromosService {
    constructor(
        private apiHttp: ApiHttp) {
    }

    public getOrders(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressPromos/GetOrdersReport', data, messageService);
    }

    public downloadOrders(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.postDownloadFile('api/AdminXpressPromos/DownloadOrdersReport', data, messageService);
    }

    public getPromos(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressPromos/GetPromos', data, messageService);
    }

    public getPromo(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressPromos/GetPromo', data, messageService);
    }

    public addOrUpdatePromo(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressPromos/AddOrUpdatePromo', data, messageService);
    }

    public updatePromoIsActive(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressPromos/UpdatePromoIsActive', data, messageService);
    }

    public getMerchantPromos(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminPromo/GetMerchantPromos', data, messageService);
    }

    public updateMerchantPromoIsActive(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminPromo/UpdateMerchantPromoIsActive', data, messageService);
    }

    public addOrUpdateMerchantPromo(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminPromo/AddOrUpdatePromo', data, messageService);
    }

    public getMerchantPromo(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminPromo/GetMerchantPromo', data, messageService);
    }

    public getGeoZonesForPromo(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressPromos/GetGeoZonesForPromo', data, messageService);
	}

	public getReferralReport(data: any, messageService: MessageService): Promise<any> {
		return this.apiHttp.post('api/AdminXpressPromos/GetReferralReport', data, messageService);
	}

	public downloadReferralReport(data: any, messageService: MessageService): Promise<any> {
		return this.apiHttp.postDownloadFile('api/AdminXpressPromos/DownloadReferralReport', data, messageService);
	}
}
